import { render, staticRenderFns } from "./AdressCard.vue?vue&type=template&id=299346f4&"
import script from "./AdressCard.vue?vue&type=script&lang=js&"
export * from "./AdressCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports